// extracted by mini-css-extract-plugin
export default {"pulsatingDotForCopyStyles":"EGoUFW2Ud1eV1Yrsxjt1"};